import React from 'react';
import { FastField } from 'formik';
import { NumberFormatInput, SelectInput } from '../../../form-helpers';
//import { config } from '../../../../helpers';


export const renderClientFacingField = ({
  labelName = 'Lite',
  infoId,
  fastFieldName,
  optionsArray,
  disabled = false,
  onInfoClick,
  handleCalculation,
  setFieldValue,
  topContainerClassName="mr-3",
  fContainerClassName="",
}) => {
  return (
    <div className={topContainerClassName}>
      <label className='mb-0'>
        {labelName}
        {
        /* config.commbank ? null : <span>
          <i
            className="fas pl-2 fa-info-circle cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onInfoClick(infoId);
            }}
          ></i>
        </span> */
        }
      </label>

      <FastField
        name={fastFieldName}
        component={SelectInput}
        options={optionsArray}
        isEdit={true}
        placeholder="$0"
        prefixLabel="$"
        onChange={(val) => handleCalculation(setFieldValue)}
        disabled={disabled}
        label=""
        containerClassName={fContainerClassName}
      />
    </div>
  );
};

export const renderDiscountedCPMField = ({
    fieldName
  }) => {
    return (
      <div className='mr-2 ww-100'>
        <FastField
          name={fieldName}
          component={NumberFormatInput}
          isEdit={true}
          placeholder="0"
          prefixLabel="$"
          minValue={0}
          decimalScale={2}
          className="text-right disabled"
          label=""
          labelClassName="d-none"
        />
      </div>
    );
  };